import colors from 'theme/colors';
import { StationIconProps } from './types';

export const Completion = ({ background = colors.darkBlue, color = colors.white, ...rest }: StationIconProps) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <circle cx="12" cy="12" r="12" fill={background} />
            <path
                d="M6 11.3333C6 10.597 6.67157 10 7.5 10H16.5C17.3284 10 18 10.597 18 11.3333V12.6667C18 13.403 17.3284 14 16.5 14H7.5C6.67157 14 6 13.403 6 12.6667V11.3333Z"
                fill={color}
            />
        </svg>
    );
};
